import { Link } from "react-router-dom"
import styles from "../../styles/AppBreadcrumb.module.css"
const PrevBreadLink = ({ previousRoute, previousTitle }) => {
  return (
    <Link to={previousRoute} className={styles.prevLink}>
      {previousTitle}
    </Link>
  )
}
export default PrevBreadLink
